import { createGenericDispatcher } from '../../action/action-dispatcher-factory';

import * as Api from '../../api/api';

export const createQuickbooksIntegration = (
  quickbooksIntegration: QuickbooksIntegrationCreateRequest,
) =>
  createGenericDispatcher({
    name: 'CREATE_QUICKBOOKS_INTEGRATION',
    loadFunction: () =>
      Api.post('/quickbooks-integration', {
        body: JSON.stringify(quickbooksIntegration),
      }),
    args: quickbooksIntegration,
  });
